module.exports = __webpack_public_path__ + "static/u2-88aa9cf8a9132888b884504c8f74c28c.png";